((obj: any) => {
  if (!obj.unique) {
    Object.defineProperty(Array.prototype, "unique", {
      enumerable: false,
      writable: true,
      configurable: true,
      value: function (func: any) {
        var result = [];
        var finalresult = [];
        func =
          func ||
          function (x: any) {
            return x;
          };
        var collection = this;
        for (var i = 0; i < collection.length; i++) {
          if (result.indexOf(func(collection[i])) === -1) {
            result.push(func(collection[i]));
            finalresult.push(collection[i]);
          }
        }
        return finalresult;
      }
    });
  }

  if (!obj.interpolate) {
    Object.defineProperty(obj, "interpolate", {
      enumerable: false,
      writable: true,
      configurable: true,
      value: function (start: any, stop: any, func: any) {
        var collection = this;
        func =
          func ||
          function (x: any) {
            return x;
          };
        for (var i = start; i < stop; i++) {
          if (collection instanceof Float32Array) {
            collection[i - start] = func(i);
          } else collection.push(func(i, i - start));
        }
        return collection;
      }
    });
  }
})(Array.prototype);

export function getStates(): any[] {
  return [
    { label: "", value: "" },
    { label: "Alabama", value: "1" },
    { label: "Alaska", value: "54" },
    { label: "Arizona", value: "2" },
    { label: "Arkansas", value: "3" },
    { label: "California", value: "4" },
    { label: "Colorado", value: "5" },
    { label: "Connecticut", value: "6" },
    { label: "Florida", value: "9" },
    { label: "Georgia", value: "10" },
    { label: "Idaho", value: "11" },
    { label: "Illinois", value: "12" },
    { label: "Indiana", value: "13" },
    { label: "Iowa", value: "14" },
    { label: "Kansas", value: "15" },
    { label: "Kentucky", value: "16" },
    { label: "Louisiana", value: "17" },
    { label: "Maine", value: "18" },
    { label: "Maryland", value: "19" },
    { label: "Massachusetts", value: "20" },
    { label: "Michigan", value: "21" },
    { label: "Minnesota", value: "22" },
    { label: "Mississippi", value: "23" },
    { label: "Missouri", value: "24" },
    { label: "Montana", value: "25" },
    { label: "Nebraska", value: "26" },
    { label: "Nevada", value: "27" },
    { label: "New Hampshire", value: "28" },
    { label: "New Jersey", value: "29" },
    { label: "New Mexico", value: "30" },
    { label: "New York", value: "31" },
    { label: "North Carolina", value: "32" },
    { label: "North Dakota", value: "33" },
    { label: "Ohio", value: "34" },
    { label: "Oklahoma", value: "35" },
    { label: "Oregon", value: "36" },
    { label: "Pennsylvania", value: "37" },
    { label: "Rhode Island", value: "38" },
    { label: "South Carolina", value: "39" },
    { label: "South Dakota", value: "40" },
    { label: "Tennessee", value: "41" },
    { label: "Texas", value: "42" },
    { label: "Utah", value: "43" },
    { label: "Vermont", value: "44" },
    { label: "Virginia", value: "45" },
    { label: "Washington", value: "46" },
    { label: "West Virginia", value: "47" },
    { label: "Wisconsin", value: "48" },
    { label: "Wyoming", value: "49" }
  ];
}
export function getValidStatesProvinces() {
  return getStates()
    .filter((x) => x.label)
    .map((v) => v.label);
}
export function isBoolean(val: any) {
  return typeof val === "boolean";
}

export function isString(val: any) {
  return typeof val === "string";
}

let zip_regex = /^[0-9]{5}(?:-[0-9]{4})?$/;
export function isZipCode(val: any) {
  let res = zip_regex.exec(val);

  return res?.length;
}

export function MinLengthAttribute(min: any, equal?: any) {
  return createValidationAttribute((val: any) => {
    if (val === undefined || val === null) {
      if (min) {
        return false;
      }
    }
    if (equal) {
      return `${val}`.length >= min;
    }
    return `${val}`.length > min;
  }, createDefaultError(`Needs to be at least ${min} long.`));
}
export function VINAttribute() {
  return createValidationAttribute((val: any) => {
    return val ? validate_vin(val) : true;
  }, createDefaultError(`Needs a valid VIN.`));
}
function validate_vin(vin: any) {
  function isnumeric(mixed_var: any) {
    return "0123456789".indexOf(`${mixed_var}`) !== -1;
  }
  var pattern = /^[^Wioq]{17}$/;
  var weights = [8, 7, 6, 5, 4, 3, 2, 10, 0, 9, 8, 7, 6, 5, 4, 3, 2];
  var transliterations: any = {
    a: 1,
    b: 2,
    c: 3,
    d: 4,
    e: 5,
    f: 6,
    g: 7,
    h: 8,
    j: 1,
    k: 2,
    l: 3,
    m: 4,
    n: 5,
    p: 7,
    r: 9,
    s: 2,
    t: 3,
    u: 4,
    v: 5,
    w: 6,
    x: 7,
    y: 8,
    z: 9
  };

  vin = vin.toLowerCase();
  if (!vin.match(pattern)) {
    return false;
  }

  var sum = 0;
  for (var i = 0; i < vin.length; i++) {
    if (!isnumeric(vin.charAt(i))) {
      sum += transliterations[vin.charAt(i)] * weights[i];
    } else {
      sum += parseInt(vin.charAt(i), 10) * weights[i];
    }
  }

  var checkdigit: any = sum % 11;
  if (checkdigit === 10) {
    // check digit of 10 represented by X
    checkdigit = "x";
  }

  return `${checkdigit}` === vin.charAt(8);
}

function createDefaultError(text: any): any {
  return {
    invalid: true,
    fail: { title: text },
    success: { title: "" }
  };
}
export interface ValidationResult {
  invalid?: boolean;
  errors: { title: any }[];
  success: { title: string }[];
}

export function MaxLengthAttribute(max: any, equal?: any) {
  return createValidationAttribute((val: any) => {
    if (val === undefined || val === null) {
      if (max) {
        return true;
      }
    }

    if (equal) {
      return `${val}`.length <= max;
    }
    return `${val}`.length < max;
  }, createDefaultError(`Needs to be less ${max} long.`));
}
export function PhoneNumberAttribute() {
  return createValidationAttribute((val: any) => {
    const phoneRegex = /^[+]?[(]?[0-9]{3}[)]?[-s.]?[0-9]{3}[-s.]?[0-9]{4,6}$/gm;
    let matches = phoneRegex.exec(val);
    return matches ? !!matches.length : false;
  }, createDefaultError(`Please input a valid US phone number.`));
}
export function EqualsModelProperty(propName: any) {
  return createValidationAttribute((val: any, object: any) => {
    return object && val === object[propName];
  }, createDefaultError(`${propName} needs to match.`));
}

export function AlphaOnlyAttribute() {
  return createValidationAttribute(alpha, createDefaultError(`Only alphabet letters.`));
}

export function AlphaNumericLikeAttribute() {
  return createValidationAttribute(alphanumericLike, createDefaultError(`Only alphanumeric characters.`));
}
export function AlphaNumericPuncLike() {
  return createValidationAttribute(alphanumericLikePunc, createDefaultError(`Only alphanumeric characters.`));
}

export function AlphaOnlyWithSpacesAttribute() {
  return createValidationAttribute(alphawithspaces, createDefaultError(`Only alphanumeric characters and spaces.`));
}

export function IsNullAttribute() {
  return createValidationAttribute((a: any) => a === null || a === undefined, createDefaultError(`This value cannot be set.`));
}

export function IsNotNullAttribute() {
  return createValidationAttribute((a: any) => a !== null && a !== undefined, createDefaultError(`This value must be set.`));
}
export function IsNotEmpty() {
  return createValidationAttribute((a: any) => a !== undefined || a !== "" || `${a}`.trim() !== "", createDefaultError(`This value must be set.`));
}
export function NotEmpty() {
  return IsNotEmpty();
}
export function OneOfAttribute(options: any) {
  return createValidationAttribute((a: any) => options.some((v: any) => v === a), createDefaultError(`Select an option.`));
}
export function MaxAttribute(max: any, equal?: any) {
  return createValidationAttribute((val: any) => {
    if (typeof val === "string") {
      val = parseFloat(val);
    }
    if (typeof val !== "number") {
      return false;
    }
    if (equal) {
      return val <= max;
    }
    return val < max;
  }, createDefaultError(equal ? `This value must be less than or equal to ${max}.` : `This value must be less than ${max}.`));
}

export function MinAttribute(min: any, equal?: any) {
  return createValidationAttribute((val: any) => {
    if (typeof val === "string") {
      val = parseFloat(val);
    }
    if (typeof val !== "number") {
      return false;
    }
    if (equal) {
      return val >= min;
    }
    return val > min;
  }, createDefaultError(equal ? `This value must be greater than or equal to ${min}.` : `This value must be greater than ${min}.`));
}

function ValidateEmail(mail: any) {
  if (
    /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(
      mail
    )
  ) {
    return true;
  }

  return false;
}

const urlpattern = /[-a-zA-Z0-9@:%._+~#=]{1,256}.[a-zA-Z0-9()]{1,6}([-a-zA-Z0-9()@:%_+.~#?&//=]*)?/gi;

const ssnPattern = /^[0-9]{3}-?[0-9]{2}-?[0-9]{4}$/;

export function SSNAttribute() {
  return createValidationAttribute((val: any) => ssnPattern.test(val), createDefaultError(`Isn't a valid Social Security Number.`));
}
export function SSNEmptyAttribute() {
  return createValidationAttribute((val: any) => {
    if (val) return ssnPattern.test(val);
    return true;
  }, createDefaultError(`Isn't a valid Social Security Number.`));
}
export function IsValidDateAttribute() {
  return createValidationAttribute((val: any) => {
    if (val === null || val === undefined) {
      return false;
    }

    const date = typeof val === "string" ? Date.parse(val) : val;
    return _isValidDate(date);
  }, createDefaultError(`Isn't a valid date.`));
}
export function isValidDate(val: any) {
  if (val === null || val === undefined) {
    return false;
  }

  if (!val && val !== 0) {
    return true;
  }
  const date = typeof val === "string" ? Date.parse(val) : val;
  return _isValidDate(date);
}
export function _isValidDate(d: any) {
  return d instanceof Date && !Number.isNaN(d as any);
}
export function IsValidDateOrEmptyAttribute() {
  return createValidationAttribute((val: any) => isValidDate(val), createDefaultError(`Isn't a valid date.`));
}
export function PastDateAttribute(_pastDate: any) {
  const pastDate: any = new Date(Date.parse(_pastDate));
  return createValidationAttribute((val: any) => {
    if (isValidDate(val)) {
      return new Date(val).getTime() >= pastDate.getTime();
    }

    return false;
  }, createDefaultError(_pastDate ? `It must be past ${new Date(_pastDate).toLocaleDateString()}.` : null));
}
export function IsValidStateOrProvince() {
  let validStates = getValidStatesProvinces();
  return createValidationAttribute((val: any) => {
    return validStates.some((v) => v === val);
  }, createDefaultError(`Please select a valid state.`));
}
export function Is18YearsPlusAttribute() {
  return createValidationAttribute((val: any) => {
    if (val === null || val === undefined) {
      return false;
    }

    if (isValidDate(val)) {
      try {
        const date = new Date(Date.parse(val));
        return Date.now() - date.getTime() > 5.676e11;
      } catch (e) {
        return false;
      }
    }

    return false;
  }, createDefaultError(`Has to be over 18.`));
}
export function CreditCardValidation() {
  return createValidationAttribute(
    (val: any) =>
      CredCardValidations.find((j) => {
        return j.startsWith.find((t) => val.startsWith(t)) && j.lengths.find((t) => val.length === t);
      }),
    createDefaultError(`It isn't recognized as a valid credit card number.`)
  );
}

export function GetCardType(x: any) {
  return CredCardValidations.find((j) => j.startsWith.find((t) => x.startsWith(t)) && j.lengths.find((t) => x.length === t));
}

const CredCardValidations = [
  { name: "American Express", startsWith: ["34", "37"], lengths: [15] },
  {
    name: "Diners Club - Carte Blanche",
    startsWith: ["300", "301", "302", "303", "304", "305"],
    lengths: [14]
  },
  { name: "Diners Club - International", startsWith: ["36"], lengths: [14] },
  { name: "Diners Club - USA & Canada", startsWith: ["54"], lengths: [16] },
  {
    name: "Discover",
    startsWith: [
      ...([] as any).interpolate(622126, 622925 + 1, (x: any) => x).map((x: any) => x.toString()),
      ...["6011", "644", "645", "646", "647", "648", "649", "65"]
    ],
    lengths: [16, 17, 18, 19]
  },
  {
    name: "InstaPayment",
    startsWith: [...[637, 638, 639].map((x) => x.toString())],
    lengths: [16]
  },
  {
    name: "JCB",
    startsWith: [...([] as any).interpolate(3528, 3589 + 1, (x: any) => x).map((x: any) => x.toString())],
    lengths: [16, 17, 18, 19]
  },
  {
    name: "Maestro",
    startsWith: [...[5018, 5020, 5038, 5893, 6304, 6759, 6761, 6762, 6763].map((x) => x.toString())],
    lengths: [16, 17, 18, 19]
  },
  {
    name: "MasterCard",
    startsWith: [...([] as any).interpolate(222100, 272099 + 1, (x: any) => x.toString()), ...[51, 52, 53, 54, 55].map((x) => x.toString())],
    lengths: [16, 17, 18, 19]
  },
  {
    name: "Visa",
    startsWith: [...[4].map((x) => x.toString())],
    lengths: [16, 13, 19]
  },
  {
    name: "Visa Electron",
    startsWith: [...[4026, 417500, 4508, 4844, 4913, 4917].map((x) => x.toString())],
    lengths: [16]
  }
];

export function BeforeNowAttribute() {
  const nowDate = new Date(Date.now());
  return createValidationAttribute((val: any) => {
    if (val === null || val === undefined) {
      return false;
    }

    if (isValidDate(val)) {
      return val.getTime() < nowDate.getTime();
    }

    return false;
  }, createDefaultError(`It needs to be in the past.`));
}

export function UrlAttribute() {
  return createValidationAttribute((val: any) => urlpattern.test(val), createDefaultError(`This isn't a valid url.`));
}
export function UrlEmptyAttribute() {
  return createValidationAttribute((val: any) => {
    if (val) return urlpattern.test(val);
    return true;
  }, createDefaultError(`This isn't a valid url.`));
}

export function EmailAttribute() {
  return createValidationAttribute((val: any) => ValidateEmail(val), createDefaultError(`This isn't a valid email address.`));
}
export function EmailEmptyAttribute() {
  return createValidationAttribute((val: any) => {
    if (val) return ValidateEmail(val);
    return true;
  }, createDefaultError(`This isn't a valid email address.`));
}

export function ZipAttribute() {
  return zipefunc(false);
}

export function ZipEmptyAttribute() {
  return zipefunc(true);
}
export function NumericAttribute() {
  return createValidationAttribute(numericint, createDefaultError(`Only numbers.`));
}
function zipefunc(allowNull: any) {
  const AllowedChars = "0123456789";
  return createValidationAttribute((val: any) => {
    if (val) {
      return val.length === 5 && val.split("").filter((v: any) => AllowedChars.indexOf(v) !== -1).length;
    }
    return allowNull || false;
  }, createDefaultError(`This isn't a valid zip code.`));
}
function createValidationAttribute(test: any, defaultOptions = {}) {
  return {
    results: (results: any, options: any = {}) => {
      options = {
        ...{ fail: { title: "test failed" }, success: { title: "test succeeded" } },
        ...defaultOptions,
        ...(options || {})
      };
      const { errors, success } = results;
      return {
        isOk: (val: any, b?: any, c?: any, d?: any, e?: any, f?: any, g?: any, h?: any, i?: any) => {
          if (test(val, b, c, d, e, f, g, h, i)) {
            if (success) {
              success.push(options.success);
            }
            return true;
          }
          if (errors) {
            errors.push(options.fail);
          }
          results.invalid = true;
          return false;
        }
      };
    }
  };
}

export function validateEmail(email: any) {
  return ValidateEmail(email);
}

export function maxLength(val: any, length: any) {
  return `${val}`.length < length;
}
export function minLength(val: any, length: any) {
  return `${val}`.length > length;
}

export function greaterThanOrEqualTo(val: any, length: any) {
  if (typeof val === "string") return `${val}`.length <= length;

  return val <= length;
}
export function numericalDefault(val: any, defaultValue: any) {
  if (val === undefined || val === null || typeof val !== "number") {
    return defaultValue;
  }
  return val;
}
export function lessThanOrEqualTo(val: any, length: any) {
  if (typeof val === "string") return `${val}`.length >= length;

  return val <= length;
}

export function equalsLength(val: any, length: any) {
  return `${val}`.length === length;
}

export function alphanumericLike(val: any) {
  return !(val || "")
    .toString()
    .split("")
    .find((t: any) => {
      t = `${t}`.toLowerCase();
      return "abcdefghijk lmnopqrstuvwxyz,.;'0123456789".indexOf(t) === -1;
    });
}
export function alphanumericLikePunc(val: any) {
  return !(val || "")
    .toString()
    .split("")
    .find((t: any) => {
      t = `${t}`.toLowerCase();
      return "abcdefghijk lmnopqrstuvwxyz,.;'0123456789?!@#$%^&*()_+-".indexOf(t) === -1;
    });
}
export function alphanumeric(val: any) {
  return !(val || "")
    .toString()
    .split("")
    .find((t: any) => {
      t = `${t}`.toLowerCase();
      return "abcdefghijklmnopqrstuvwxyz0123456789".indexOf(t) === -1;
    });
}
export function numericint(val: any) {
  return !(val || "")
    .toString()
    .split("")
    .find((t: any) => {
      t = `${t}`.toLowerCase();
      return "0123456789".indexOf(t) === -1;
    });
}
export function alpha(val: any) {
  return !(val || "")
    .toString()
    .split("")
    .find((t: any) => {
      t = `${t}`.toLowerCase();
      return "abcdefghijklmnopqrstuvwxyz".indexOf(t) === -1;
    });
}

export function alphawithspaces(val: any) {
  return !(val || "")
    .toString()
    .split("")
    .find((t: any) => {
      t = `${t}`.toLowerCase();
      return "abcdefghijklmnopqrstuvwxyz  ".indexOf(t) === -1;
    });
}
export function arrayLength(val: any) {
  if (Array.isArray(val)) {
    return val.length;
  }
  if (val && val.length) {
    return val.length;
  }
  return 0;
}
